import { useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { userDeleteSubmission as deleteSubmissionService } from '../../../services/form/FormService';

interface Values {
  isLoading: boolean;
  deleteSubmission: (organizationId: string, formId: string, submissionId: string) => Promise<number>;
}

const useDeleteSubmission = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const deleteSubmission = async (organizationId: string, formId: string, submissionId: string): Promise<number> => {
    try {
      setIsLoading(true);

      const result = await deleteSubmissionService(organizationId, formId, submissionId);
      setIsLoading(false);
      return result.data;
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return 0;
    }
  };

  return { deleteSubmission, isLoading };
};

export default useDeleteSubmission;
